
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"7","height":"15","viewBox":"0 0 7 15"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"id":"Group_2336","data-name":"Group 2336","transform":"translate(-987 -387)"}},[_c('path',{attrs:{"id":"Polygon_18","data-name":"Polygon 18","d":"M3.5,0,7,6H0Z","transform":"translate(994 402) rotate(180)","fill":"currentColor"}}),_c('path',{attrs:{"id":"Polygon_19","data-name":"Polygon 19","d":"M3.5,0,7,6H0Z","transform":"translate(987 387)","fill":"#D8DFE3"}})])])
          )
        }
      }
    